<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">{{ 'version.title' | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-3">
                {{ 'version.version' | translate }}:
            </div>
            <div class="col-9">
                <div class="fw-bold">{{version}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                {{ 'version.language' | translate }}:
            </div>
            <div class="col-9">
                <div class="fw-bold"> {{ 'languages.' + language | translate }}</div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'shared.closeBtn' | translate }}</button>
    </div>
</div>